import { Suspense, lazy } from 'react';

const CookieDisclaimer = lazy(() => import('./cookieDisclaimer'));

interface CookieDisclaimerProps {
    close: () => void;
}

export const CookieDisclaimerAsync = (props: CookieDisclaimerProps) => (
    <Suspense>
        <CookieDisclaimer {...props}/>
    </Suspense>
);
